module.exports = __webpack_public_path__ + "static/img/img_17.cb21d12e.png";